// extracted by mini-css-extract-plugin
export var actionIcon = "_tp-0";